import type { FieldDescriptor } from '../MasterDocument.types';

/**
 * Visibilidad por estado de un campo de LÍNEA en el modal (SBC-3846).
 *
 * Trata `visibleOn` igual que el filtro de FactBox del kit, de modo que un array
 * vacío significa "visible en ningún estado" = oculto:
 *
 * - `visibleOn` ausente/undefined → sin restricción → visible (retrocompatible).
 * - `visibleOn: []`               → visible en ningún estado → OCULTO.
 * - `visibleOn: ['*']`            → siempre visible.
 * - `visibleOn: ['DRAFT', ...]`   → visible solo en esos estados.
 *
 * Nota: SOLO aplica a campos de línea/línea-detalle. El filtro de cabecera
 * conserva el comportamiento histórico (un `[]` de cabecera sigue siendo visible)
 * porque hay campos de header que dependen de ello.
 */
export function isLineFieldVisibleInState(
  field: Pick<FieldDescriptor, 'visibleOn'>,
  docState: string,
): boolean {
  if (!field.visibleOn) return true;
  return field.visibleOn.includes('*') || field.visibleOn.includes(docState);
}
